"use client"

import { ComponentConfig } from "@measured/puck"
import { useState } from "react"
import { configs, DefaultImage } from "../../../../external-components"
import { DataSettingItem } from "../../../types"
export interface SocialLink {
  img: string
  link: string
}

export interface FooterProps {
  items: SocialLink[]
}
export const RenderConfig: ComponentConfig<FooterProps> = {
  render: ({ items }) => {
    const [settingsData, setSettingsData] = useState<DataSettingItem[]>([])

    const id = `form-register-${Math.random().toString(36).substr(2, 9)}`

    return (
      <>
        <div className="min-h-[511px]">
          <div className="flex sm:flex-row flex-col sm:px-[340px] pt-[25px] px-[95px] gap-4 text-black-quinary sm:pt-[186px] pb-[52px] justify-between items-center">
            <p className="sm:text-[17px] sm:leading-[22.4px] leading-[21px] pb-2 sm:px-[13.5px] font-normal text-[13px] hover:underline hover:cursor-pointer sm:w-[142px] text-center sm:h-10 flex items-center">
              Privacy Policy
            </p>
            <p className="sm:text-[17px] sm:leading-[22.4px] leading-[21px] pb-[10px] font-normal text-[13px] hover:underline hover:cursor-pointer sm:w-[142px] text-center h-10 flex items-center">
              Terms of Service
            </p>
          </div>
          <div className="flex sm:px-[236px] px-[52px] sm:pb-[10px] pb-[138px]">
            <div>
              <svg
                style={{ fill: "rgb(59, 200, 115)" }}
                data-bbox="41.501 20 116.999 160.001"
                viewBox="0 0 200 200"
                className="sm:h-[29px] sm:w-[29px] h-5 w-5"
                xmlns="http://www.w3.org/2000/svg"
                data-type="shape"
              >
                <g>
                  <path d="M157.367 66.82c-3.105-14.146-10.205-25.614-21.1-34.083-14.606-11.356-31.093-15.144-48.998-11.261-10.993 2.385-20.647 7.708-28.696 15.821-8.462 8.531-13.882 18.86-16.109 30.7-1.122 5.953-1.262 11.473-.43 16.874.862 5.609 2.729 10.685 4.442 14.912 4.273 10.539 9.918 20.076 14.358 27.205 8.241 13.235 17.874 26.672 29.45 41.082a248.399 248.399 0 0 0 3.199 3.874l6.694 8.057 5.455-6.944c13.755-16.57 25.171-32.357 34.9-48.262 6.309-10.316 10.816-19.203 14.182-27.969 3.898-10.164 4.793-20.259 2.653-30.006zM119.04 91.152c-5.093 5.141-11.835 7.976-18.984 7.983h-.025c-14.797.001-26.848-12.115-26.872-27.02-.023-14.812 11.962-26.911 26.717-26.972 7.134-.006 13.868 2.764 18.978 7.868 5.141 5.136 7.982 11.955 8 19.2.019 7.109-2.756 13.835-7.814 18.941z"></path>
                </g>
              </svg>
            </div>
            <p className="sm:px-[28px] sm:text-base sm:leading-[22.4px] text-[12px] text-center mt-[3px] text-black-quinary">
              470 North Bridge Road, #05-12 Bugis Cube, Singapore (188735)
            </p>
          </div>
          <div className="flex sm:px-[345px] px-[47px] pb-[17px] gap-[10px] sm:pb-[47px] sm:pt-[67px] sm:justify-center justify-between">
            {items.map((item, index) => (
              <a href={item.link || "#"} key={index} target="_blank" rel="noopener noreferrer">
                <img
                  src={item.img ? `${configs.API_URL}${item.img}` : DefaultImage}
                  alt={`Slide ${index}`}
                  className="sm:w-10 sm:h-10 h-[25px] w-[25px] rounded-full"
                />
              </a>
            ))}
          </div>
          <div className="sm:px-[155px] sm:pb-[45px] px-[10px] pb-[10px]">
            <p className="sm:text-sm sm:leading-[22.4px] font-extralight text-black-quinary text-center sm:px-0 px-[25px] text-xs">
              © 2022 All Rights Reserved by Skylink Studio.
            </p>
          </div>
        </div>
      </>
    )
  },
}
